import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const SEARCH_PARAM = 'q';

export default function useDeviceListSearch () {
  const { search: queryString } = useLocation();
  const history = useHistory();

  const search = useMemo(() => new URLSearchParams(queryString).get(SEARCH_PARAM) ?? '', [queryString]);

  const setSearch = useCallback((next: string) => {
    const params = new URLSearchParams(history.location.search);
    const term = next.trim();
    if (term) {
      params.set(SEARCH_PARAM, term);
    } else {
      params.delete(SEARCH_PARAM);
    }
    const query = params.toString();
    history.replace({ pathname: history.location.pathname, search: query ? `?${query}` : '' });
  }, [history]);

  return [search, setSearch] as const;
}
